import { RouterProvider } from '@tanstack/react-router'
import { router } from './App'
import { useAuth } from './utils/Auth/useAuth'

const InnerApp = () => {
    const auth = useAuth()
    return <RouterProvider router={router} context={{ auth }} />
}

export default InnerApp